import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdaptiveTableCell, Guideline } from '@components/common';

import { IRUCarrierState } from '@interfaces/ruStatusDashboard/ruStatusDashboard';

import { EActionButtonTypes } from '@enums/common';

import ActionButton from '../../AssetsRent/RequestReservationCard/ApprovalUnitsModal/ActionButton';

import styles from './CarrierStateTable.module.scss';

interface IRUCarrierStateProps {
	handleSleep: (data: IRUCarrierState) => void;
	handleInactivate: (data: IRUCarrierState) => void;
	handleActivate: (data: IRUCarrierState) => void;
	isSleepAvailable: boolean;
	isInactivateAvailable: boolean;
	isActivateAvailable: boolean;
}

const columnHelper = createColumnHelper<IRUCarrierState>();

export const getColumns = ({
	handleSleep,
	handleInactivate,
	handleActivate,
	isSleepAvailable,
	isInactivateAvailable,
	isActivateAvailable,
 }: IRUCarrierStateProps): ColumnDef<any>[] => [
	columnHelper.accessor('name', {
		header: 'Name',
		cell: ({ row: { original } }: CellContext<IRUCarrierState, any>) => {
			const { name, carriers } = original;

			return (
				<div className={styles.guidelineCell}>
					<AdaptiveTableCell text={name} />
					<Guideline guidelineText={carriers} />
				</div>
			);
		},
	}),
	columnHelper.accessor('active', {
		header: 'Active',
		cell: ({ getValue }: CellContext<IRUCarrierState, any>) => {
			const { title, color } = getValue() || '-';

			return (
				<AdaptiveTableCell
					color={color}
					text={title}
				/>
			);
		},
	}),
	columnHelper.accessor('state', {
		header: 'State',
		cell: ({ getValue }: CellContext<IRUCarrierState, any>) => {
			const { title, color } = getValue() || '-';

			return (
				<AdaptiveTableCell
					color={color}
					text={title}
				/>
			);
		},
	}),
	columnHelper.accessor('actions', {
		header: 'Actions',
		enableSorting: false,
		cell: ({ row: { original } }: CellContext<IRUCarrierState, any>) => {
			const sleepHandler = () => {
				handleSleep(original);
			};

			const inactivateHandler = () => {
				handleInactivate(original);
			};

			const activateHandler = () => {
				handleActivate(original);
			};

			return (
				<div className={styles.actionsWrapper}>
					{isActivateAvailable && (
						<ActionButton
							onClick={activateHandler}
							style={EActionButtonTypes.approve}
							text='Activate'
						/>
					)}
					{isSleepAvailable && (
						<ActionButton
							onClick={sleepHandler}
							style={EActionButtonTypes.sleep}
							text='Sleep'
						/>
					)}
					{isInactivateAvailable && (
						<ActionButton
							onClick={inactivateHandler}
							style={EActionButtonTypes.disapprove}
							text='Inactivate'
						/>
					)}
				</div>
			);
		},
	}),
];
